import { render, staticRenderFns } from "./home.vue?vue&type=template&id=50f97cd4&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=50f97cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f97cd4",
  null
  
)

export default component.exports